import { DeleteIcon } from '@blocksuite/icons/rc';
import type { ConfirmModalProps, MenuItemProps } from '@pique/component';
import { ConfirmModal, MenuItem } from '@pique/component';
import { useI18n } from '@pique/i18n';

export const MoveToTrash = (props: MenuItemProps) => {
  const t = useI18n();

  return (
    <MenuItem prefixIcon={<DeleteIcon />} type="danger" {...props}>
      {t['com.pique.moveToTrash.title']()}
    </MenuItem>
  );
};

const MoveToTrashConfirm = ({
  titles,
  ...confirmModalProps
}: {
  titles: string[];
} & ConfirmModalProps) => {
  const t = useI18n();
  const multiple = titles.length > 1;
  const title = multiple
    ? t['com.pique.moveToTrash.confirmModal.title.multiple']({
        number: titles.length.toString(),
      })
    : t['com.pique.moveToTrash.confirmModal.title']();
  const description = multiple
    ? t['com.pique.moveToTrash.confirmModal.description.multiple']({
        number: titles.length.toString(),
      })
    : t['com.pique.moveToTrash.confirmModal.description']({
        title: titles[0] || t['Untitled'](),
      });
  return (
    <ConfirmModal
      title={title}
      description={description}
      cancelText={t['com.pique.confirmModal.button.cancel']()}
      confirmText={t.Delete()}
      confirmButtonOptions={{
        ['data-testid' as string]: 'confirm-delete-page',
        variant: 'error',
      }}
      {...confirmModalProps}
    />
  );
};

MoveToTrash.ConfirmModal = MoveToTrashConfirm;
